/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProductTypeEnum = "Business_NonStandard" | "Business_Standard" | "Enterprise_NonStandard" | "Enterprise_Standard" | "Pro_NonStandard" | "Pro_Standard" | "%future added value";
export type SubscriptionTypeEnum = "Expired" | "FreemiumOrg" | "LegacyPrePaywall" | "PaidBillingGroup" | "PaidOrgPro" | "PaidTeamPro" | "PaidUserPro" | "SelfServePremiumOrgQ42020" | "SelfServePremiumTeamQ12021" | "%future added value";
export type ChromeMenuDrawer_viewer = {
    readonly user: {
        readonly id: string;
        readonly emails: ReadonlyArray<string>;
        readonly givenName: string | null;
        readonly familyName: string | null;
        readonly externalImageUrl: string | null;
        readonly dataSources: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly status: number | null;
                    readonly name: string | null;
                } | null;
            } | null> | null;
        } | null;
        readonly orgs: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly domains: ReadonlyArray<string | null> | null;
                    readonly personForUserErrorable: {
                        readonly __typename: "GraphEntityError";
                        readonly message: string | null;
                    } | {
                        readonly __typename: "Person";
                        readonly id: string;
                        readonly primaryEmail: string;
                        readonly emails: ReadonlyArray<string>;
                        readonly isYou: boolean;
                        readonly userId: string | null;
                        readonly isUser: boolean;
                        readonly profile: {
                            readonly givenName: string | null;
                            readonly familyName: string | null;
                            readonly externalImageUrl: string | null;
                        } | null;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    };
                    readonly slackAccountsErrorable: {
                        readonly __typename: "SlackAccountList";
                        readonly list: ReadonlyArray<{
                            readonly id: string;
                            readonly slackTeamId: string | null;
                            readonly slackUserId: string | null;
                            readonly teamDisplayName: string | null;
                        }>;
                    } | {
                        readonly __typename: "GraphEntityError";
                        readonly message: string | null;
                        readonly statusCode: number | null;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    };
                    readonly eventColoringSettingsErrorable: {
                        readonly __typename: "GraphEntityError";
                        readonly statusCode: number | null;
                        readonly message: string | null;
                    } | {
                        readonly __typename: "EventColoringSettings";
                        readonly eventCategoryColorings: ReadonlyArray<{
                            readonly googleColorKey: string | null;
                            readonly eventCategory: string;
                            readonly active: boolean;
                            readonly isUserSet: boolean;
                        }> | null;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    };
                    readonly primaryTeam: ({
                        readonly __typename: "Team";
                        readonly teamId: string;
                    } | {
                        readonly __typename: "GraphEntityError";
                        readonly statusCode: number | null;
                        readonly message: string | null;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    }) | null;
                    readonly featureGrid: {
                        readonly __typename: "FeatureGrid";
                        readonly stateMetadata: {
                            readonly primaryBillingGroupMetadata: {
                                readonly subscription: {
                                    readonly id: string;
                                    readonly type: SubscriptionTypeEnum | null;
                                    readonly productType: ProductTypeEnum | null;
                                };
                            } | null;
                        };
                    } | {
                        readonly __typename: "GraphEntityError";
                        readonly statusCode: number | null;
                        readonly message: string | null;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    };
                } | null;
            } | null> | null;
        };
    } | null;
    readonly " $refType": "ChromeMenuDrawer_viewer";
};
export type ChromeMenuDrawer_viewer$data = ChromeMenuDrawer_viewer;
export type ChromeMenuDrawer_viewer$key = {
    readonly " $data"?: ChromeMenuDrawer_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ChromeMenuDrawer_viewer">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emails",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "givenName",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "familyName",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalImageUrl",
        "storageKey": null
    } as any, v5 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v9 = {
        "kind": "InlineFragment",
        "selections": [
            (v8 /*: any*/),
            (v7 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "ChromeMenuDrawer_viewer",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/),
                    (v2 /*: any*/),
                    (v3 /*: any*/),
                    (v4 /*: any*/),
                    {
                        "alias": null,
                        "args": (v5 /*: any*/),
                        "concreteType": "DataSourceConnection",
                        "kind": "LinkedField",
                        "name": "dataSources",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DataSourceEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DataSource",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "status",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "name",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "dataSources(first:1000000)"
                    },
                    {
                        "alias": null,
                        "args": (v5 /*: any*/),
                        "concreteType": "OrgConnection",
                        "kind": "LinkedField",
                        "name": "orgs",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Org",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "domains",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "personForUserErrorable",
                                                "plural": false,
                                                "selections": [
                                                    (v6 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            (v7 /*: any*/)
                                                        ],
                                                        "type": "GraphEntityError",
                                                        "abstractKey": null
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            (v0 /*: any*/),
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "primaryEmail",
                                                                "storageKey": null
                                                            },
                                                            (v1 /*: any*/),
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "isYou",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "userId",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "isUser",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "UserProfile",
                                                                "kind": "LinkedField",
                                                                "name": "profile",
                                                                "plural": false,
                                                                "selections": [
                                                                    (v2 /*: any*/),
                                                                    (v3 /*: any*/),
                                                                    (v4 /*: any*/)
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "Person",
                                                        "abstractKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "slackAccountsErrorable",
                                                "plural": false,
                                                "selections": [
                                                    (v6 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "SlackAccount",
                                                                "kind": "LinkedField",
                                                                "name": "list",
                                                                "plural": true,
                                                                "selections": [
                                                                    (v0 /*: any*/),
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "slackTeamId",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "slackUserId",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "teamDisplayName",
                                                                        "storageKey": null
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "SlackAccountList",
                                                        "abstractKey": null
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            (v7 /*: any*/),
                                                            (v8 /*: any*/)
                                                        ],
                                                        "type": "GraphEntityError",
                                                        "abstractKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "eventColoringSettingsErrorable",
                                                "plural": false,
                                                "selections": [
                                                    (v6 /*: any*/),
                                                    (v9 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "EventCategoryColoring",
                                                                "kind": "LinkedField",
                                                                "name": "eventCategoryColorings",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "googleColorKey",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "eventCategory",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "active",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "isUserSet",
                                                                        "storageKey": null
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "EventColoringSettings",
                                                        "abstractKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "primaryTeam",
                                                "plural": false,
                                                "selections": [
                                                    (v6 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "teamId",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "Team",
                                                        "abstractKey": null
                                                    },
                                                    (v9 /*: any*/)
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "featureGrid",
                                                "plural": false,
                                                "selections": [
                                                    (v6 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "PaymentStateMetadata",
                                                                "kind": "LinkedField",
                                                                "name": "stateMetadata",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "PrimaryBillingGroupMetadata",
                                                                        "kind": "LinkedField",
                                                                        "name": "primaryBillingGroupMetadata",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": "PaymentSubscription",
                                                                                "kind": "LinkedField",
                                                                                "name": "subscription",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    (v0 /*: any*/),
                                                                                    {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "kind": "ScalarField",
                                                                                        "name": "type",
                                                                                        "storageKey": null
                                                                                    },
                                                                                    {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "kind": "ScalarField",
                                                                                        "name": "productType",
                                                                                        "storageKey": null
                                                                                    }
                                                                                ],
                                                                                "storageKey": null
                                                                            }
                                                                        ],
                                                                        "storageKey": null
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "FeatureGrid",
                                                        "abstractKey": null
                                                    },
                                                    (v9 /*: any*/)
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "orgs(first:1000000)"
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Viewer",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '3b8531899ffefffc0276af1e6589beb8';
export default node;
